<div class="row">
  <div class="col-12">
    <sb-card [loading]="loading">
      <div card-fit>
        <sb-wizard #wizard classes="wizard__minHeightSetting overflow-hidden">
          <sb-wizard-tab #tab1 titleText="{{ 'lang.wizard.tabs.settings' | translate }}" icon="basicSettings"
                         [disabled]="wizardState!=='Map'">
            <form [formGroup]="form" class="wizard__forms px-5">
              <h3 class="mb-4">{{'lang.scheduleEdit.settingsHeadline' | translate}}</h3>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group validateMe">
                    <label class="form-label" for="Title">{{'lang.scheduleEdit.title' | translate}}<span class="red">*</span></label>
                    <input type="text" id="Title" class="form-control" formControlName="Title" sbAutofocus>
                    <span class="form-text text-muted">{{'lang.scheduleEdit.titleDescription' | translate}}</span>
                    <div *ngIf="Title.dirty && Title.errors?.required" class="alert alert-danger">
                      {{'lang.scheduleEdit.titleWarning' | translate}}</div>
                  </div>
                </div>
              </div>
            </form>
            <div class="row px-5">
              <div class="col-md-6">
                <div class="form-group validateMe">
                  <label class="form-label" for="Precondition">{{'lang.globals.precondition' | translate}}</label>
                  <select id="Precondition" class="form-select" [ngModel]="precondition"
                          (ngModelChange)="updatePrecondition($event)">
                    <option [value]="null" class="font-weight-bold">{{'lang.globals.noPrecondition'|translate}}</option>
                    <option *ngFor="let sched of schedules"
                            [ngValue]="sched">{{sched.name}}</option>
                  </select>
                  <span class="form-text text-muted">{{'lang.globals.preconditionDescription' | translate}}</span>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group validateMe">
                  <label class="form-label" for="Position">{{'lang.globals.position' | translate}}</label>
                  <select id="Position" class="form-select" [ngModel]="pickedPosition"
                          (ngModelChange)="updatePosition($event)">
                    <option *ngFor="let sched of preconditions"
                            [ngValue]="sched"
                            [ngClass]="{'font-weight-bold': sched?.id?.toString() === scheduleId?.toString()}">
                      {{sched?.id?.toString() === scheduleId?.toString() ?
                      ('lang.globals.holdPosition' | translate) : sched.name}}</option>
                    <option [value]="null" class="font-weight-bold">{{'lang.globals.positionAtEnd'|translate}}</option>
                  </select>
                  <span class="form-text text-muted">{{'lang.globals.positionDescription' | translate}}</span>
                </div>
              </div>
              <!--
              <div class="col-md-6">
                <div class="form-group validateMe">
                  <label for="Priority">{{'lang.globals.position' | translate}}</label>
                  <input type="number" id="Priority" class="form-control" formControlName="Priority">
                  <span class="form-text text-muted">{{'lang.globals.positionDescription' | translate}}</span>
                </div>
              </div>
              -->
              <!-- //  TODO If / When ScheduleLevelDTO is introduced
              <div class="col-md-6">
                <div class="form-group validateMe">
                  <label for="Level">
              {{'lang.globals.level' | translate}}
              </label>
              <div class="d-flex align-items-center justify-content-center">
                <select [attr.disabled]="Title.value ? null : 'disabled'" id="Level"
                        class="form-control flex-grow-1 mr-3" formControlName="Level">
                  <option *ngFor="let level of scheduleLevel" [ngValue]="level"
                          [selected]="schedule && schedule?.level? schedule.level : level">
                    {{level}}</option>
                </select>
                <button (click)="showEditLevel()"
                        class="btn btn-hover-primary" ngbTooltip="{{'lang.globals.createNewLevel' | translate}}"
                        placement="top">
                  <fa-icon icon="layer-group"></fa-icon>
                </button>
              </div>
              <span class="form-text text-muted">{{'lang.globals.campaignLevelDescription' | translate}}</span>
              <div *ngIf="Level.touched && Level.errors?.required" class="alert alert-danger">
                {{'lang.globals.levelWarning' | translate}}</div>
            </div>
    </div>
    -->


            </div>
            <div class="wizard__footerActions px-5">
              <sb-button (click)="util.returnToNavigation(util.RoutingID.schedules)"
                         classes="btn-default btn-lg btn-wide">{{'lang.globals.cancel' | translate}}</sb-button>
              <sb-button (submitClicked)="nextStep(wizard, tab2)" classes="btn-primary btn-wide btn-lg"
                         [disabled]="!form.valid">{{'lang.globals.next' | translate}}</sb-button>
            </div>

          </sb-wizard-tab>
          <sb-wizard-tab #tab2 titleText="{{ 'lang.globals.validity' | translate }}" icon="selection">
            <div class="wizard__forms px-5">
              <div class="d-flex justify-content-between align-items-center mb-4">
                <h3>{{'lang.scheduleEdit.cullHeadline' | translate}}</h3>
                <!--                <h6>
                                  <fa-icon [icon]="['fas','map-marker-alt']"></fa-icon>
                                  {{previewSchedule?.playerAggregation?.locations | sbNumberFormat}}
                                  {{'lang.scheduleEdit.locations' | translate}} / <fa-icon [icon]="['fas','desktop']"></fa-icon>
                                  {{previewSchedule?.playerAggregation?.screens | sbNumberFormat}}
                                  {{'lang.scheduleEdit.player' | translate}}
                                </h6>-->
              </div>
              <div *ngPermissions="[permissionService.Permission.cull_show]" class="wizard__forms__filterWrapper">
                <div class="wizard__forms__filterWrapper__filterStep">
                  <div
                    class="wizard__forms__filterWrapper__filterStep__singleFilter wizard__forms__filterWrapper__filterStep__singleFilter__headline">
                    <h6>{{'lang.scheduleEdit.cullSubheadline' | translate}}</h6>
                  </div>
                </div>
                <div class="wizard__forms__filterWrapper__filterStep">
                  <!--                  <div class="wizard__forms__filterWrapper__filterStep__singleFilter">
                    <div class="wizard__forms__filterWrapper__filterStep__icon">
                      <fa-icon icon="calendar"></fa-icon>
                    </div>
                  </div>-->
                  <div
                    [ngClass]="{'wizard__forms__filterWrapper__filterStep__singleFilter--active' : wizardState.startsWith('TimeCull')}"
                    class="wizard__forms__filterWrapper__filterStep__singleFilter">
                    <div class="wizard__forms__filterWrapper__filterStep__icon">
                      <sb-icon [ngClass]="{'blue' : schedule?.timeCull}" icon="calendar"></sb-icon>
                    </div>
                    <div class="wizard__forms__filterWrapper__filterStep__label">
                      <h3 *ngIf="this.schedule?.timeCull?.name">{{ schedule?.timeCull?.name }}</h3>
                      <label class="form-label">{{'lang.globals.timeFilter' | translate}}</label>
                    </div>
                    <div class="wizard__forms__filterWrapper__filterStep__options">
                      <sb-button *ngPermissions="[permissionService.Permission.cull_list]"
                                 (click)="changeWizardState('TimeCullSelect')" container="body"
                                 ngbTooltip="{{'lang.globals.selectFilter' | translate }}" placement="top"
                                 classes="btn-hover-primary m-0 green {{wizardState==='TimeCullSelect' ? 'btn-hover-primary--active' : ''}}">
                        <sb-icon icon="list"></sb-icon>
                      </sb-button>
                      <span class="btn-separator">|</span>
                      <sb-button
                        *ngIf="!this.schedule?.timeCull && permissionService.hasPermissions([permissionService.Permission.cull_time_create])"
                        (click)="changeWizardState('TimeCullEdit')"
                        ngbTooltip="{{'lang.globals.createFilter' | translate }}" placement="top" container="body"
                        classes="btn-hover-primary m-0 green {{wizardState==='TimeCullEdit' ? 'btn-hover-primary--active' : ''}}">
                        <sb-icon icon="plus"></sb-icon>
                      </sb-button>
                      <sb-button
                        *ngIf="this.schedule?.timeCull && !this.schedule?.timeCull?.global && permissionService.hasPermissions([permissionService.Permission.cull_time_edit])"
                        (click)="changeWizardState('TimeCullEdit')"
                        ngbTooltip="{{'lang.globals.editFilter' | translate }}" placement="top" container="body"
                        classes="btn-hover-primary {{wizardState==='TimeCullEdit' ? 'btn-hover-primary--active' : ''}}">
                        <sb-icon icon="edit"></sb-icon>
                      </sb-button>
                      <sb-button *ngIf="this.schedule?.timeCull" (click)="sliceCull($event, 'TimeCull')"
                                 ngbTooltip="{{'lang.globals.removeFilterFromSelection' | translate }}" placement="top"
                                 container="body"
                                 classes="btn-hover-primary m-0 red">
                        <sb-icon icon="trash"></sb-icon>
                      </sb-button>
                    </div>
                  </div>
                </div>

                <div class="wizard__forms__filterWrapper__filterStep">
                  <div
                    [ngClass]="{'wizard__forms__filterWrapper__filterStep__singleFilter--active' : wizardState.startsWith('PlayerCull')}"
                    class="wizard__forms__filterWrapper__filterStep__singleFilter">
                    <div class="wizard__forms__filterWrapper__filterStep__icon">
                      <sb-icon [ngClass]="{'blue' : schedule?.playerCull}" icon="playerOnline"></sb-icon>
                    </div>
                    <div class="wizard__forms__filterWrapper__filterStep__label">
                      <h3 *ngIf="this.schedule?.playerCull?.name">{{ schedule?.playerCull?.name }}</h3>
                      <label class="form-label">{{'lang.globals.playerFilter' | translate}}</label>
                    </div>
                    <div class="wizard__forms__filterWrapper__filterStep__options">
                      <sb-button *ngPermissions="[permissionService.Permission.cull_list]"
                                 (click)="changeWizardState('PlayerCullSelect')"
                                 ngbTooltip="{{'lang.globals.selectFilter' | translate }}" placement="top"
                                 container="body"
                                 classes="btn-hover-primary m-0 green {{wizardState==='PlayerCullSelect' ? 'btn-hover-primary--active' : ''}}">
                        <sb-icon icon="list"></sb-icon>
                      </sb-button>
                      <span class="btn-separator">|</span>
                      <sb-button
                        *ngIf="!this.schedule?.playerCull && permissionService.hasPermissions([permissionService.Permission.cull_player_create])"
                        (click)="changeWizardState('PlayerCullEdit')"
                        ngbTooltip="{{'lang.globals.createFilter' | translate }}" placement="top" container="body"
                        classes="btn-hover-primary m-0 green {{wizardState==='PlayerCullEdit' ? 'btn-hover-primary--active' : ''}}">
                        <sb-icon icon="plus"></sb-icon>
                      </sb-button>
                      <sb-button
                        *ngIf="this.schedule?.playerCull && !this.schedule?.playerCull?.global && permissionService.hasPermissions([permissionService.Permission.cull_player_edit])"
                        (click)="changeWizardState('PlayerCullEdit')"
                        ngbTooltip="{{'lang.globals.editFilter' | translate }}" placement="top" container="body"
                        classes="btn-hover-primary {{wizardState==='PlayerCullEdit' ? 'btn-hover-primary--active' : ''}}">
                        <sb-icon icon="edit"></sb-icon>
                      </sb-button>
                      <sb-button *ngIf="this.schedule?.playerCull" (click)="sliceCull($event, 'PlayerCull')"
                                 ngbTooltip="{{'lang.globals.removeFilterFromSelection' | translate }}" placement="top"
                                 container="body"
                                 classes="btn-hover-primary m-0 red">
                        <sb-icon icon="trash"></sb-icon>
                      </sb-button>
                    </div>
                  </div>
                </div>

                <div class="wizard__forms__filterWrapper__filterStep">
                  <!--                  <div class="wizard__forms__filterWrapper__filterStep__singleFilter">
                                      <div class="wizard__forms__filterWrapper__filterStep__icon">
                                        <fa-icon icon="desktop"></fa-icon>
                                      </div>
                                    </div>-->
                  <div
                    [ngClass]="{'wizard__forms__filterWrapper__filterStep__singleFilter--active' : wizardState.startsWith('GeoCull')}"
                    class="wizard__forms__filterWrapper__filterStep__singleFilter">
                    <div class="wizard__forms__filterWrapper__filterStep__icon">
                      <sb-icon [ngClass]="{'blue' : schedule?.geoCull}" icon="globe"></sb-icon>
                    </div>
                    <div class="wizard__forms__filterWrapper__filterStep__label">
                      <h3 *ngIf="this.schedule?.geoCull?.name">{{ schedule?.geoCull?.name }}</h3>
                      <label class="form-label">{{'lang.globals.geoFilter' | translate}}</label>
                    </div>
                    <div class="wizard__forms__filterWrapper__filterStep__options">
                      <sb-button *ngPermissions="[permissionService.Permission.cull_list]"
                                 (click)="changeWizardState('GeoCullSelect')"
                                 ngbTooltip="{{'lang.globals.selectFilter' | translate }}" placement="top"
                                 container="body"
                                 classes="btn-hover-primary m-0 green {{wizardState==='GeoCullSelect' ? 'btn-hover-primary--active' : ''}}">
                        <sb-icon icon="list"></sb-icon>
                      </sb-button>
                      <span class="btn-separator">|</span>
                      <sb-button
                        *ngIf="!this.schedule?.geoCull && permissionService.hasPermissions([permissionService.Permission.cull_geo_create])"
                        (click)="changeWizardState('GeoCullEdit')"
                        ngbTooltip="{{'lang.globals.createFilter' | translate }}" placement="top" container="body"
                        classes="btn-hover-primary m-0 green {{wizardState==='GeoCullEdit' ? 'btn-hover-primary--active' : ''}}">
                        <sb-icon icon="plus"></sb-icon>
                      </sb-button>
                      <sb-button
                        *ngIf="this.schedule?.geoCull && !this.schedule?.geoCull?.global && permissionService.hasPermissions([permissionService.Permission.cull_geo_edit])"
                        (click)="changeWizardState('GeoCullEdit')"
                        ngbTooltip="{{'lang.globals.editFilter' | translate }}" placement="top" container="body"
                        classes="btn-hover-primary {{wizardState==='GeoCullEdit' ? 'btn-hover-primary--active' : ''}}">
                        <sb-icon icon="edit"></sb-icon>
                      </sb-button>
                      <sb-button *ngIf="this.schedule?.geoCull" (click)="sliceCull($event, 'GeoCull')"
                                 ngbTooltip="{{'lang.globals.removeFilterFromSelection' | translate }}" placement="top"
                                 container="body"
                                 classes="btn-hover-primary m-0 red">
                        <sb-icon icon="trash"></sb-icon>
                      </sb-button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="wizard__footerActions">
                <button type="button" [disabled]="wizardState!=='Map'" (click)="nextStep(wizard, tab1)"
                           class="btn btn-default btn-wide btn-lg">{{'lang.globals.previous' | translate}}</button>
                <button [disabled]="wizardState!=='Map'"
                           ngbTooltip="{{wizardState!=='Map' ? ('lang.globals.exitFilterMode' | translate) : ''}}"
                           placement="top" container="body" type="button"
                           (click)="createAndUpdateSchedule()" class="btn btn-success btn-wide btn-lg">
                  {{'lang.globals.submit' | translate}}</button>
              </div>
            </div>
          </sb-wizard-tab>
          <div style="background-color: #f3f6f9;"
               class="wizard__aside wizard__aside--half wizard__aside--right p-0 flex-column">
            <div *ngIf="wizardState!=='Map'" class="w-100 d-flex px-4 pt-4 justify-content-end">
              <button (click)="changeWizardState('Map')" class="btn btn-hover-primary d-flex align-items-center">
                <sb-icon icon="cancel" class="icon-in-btn mr-1"></sb-icon>
                {{'lang.globals.closeFilterSelection' | translate}}
              </button>
            </div>

            <filter-edit class="w-100 p-4" *ngIf="wizardState==='TimeCullEdit'" [isInSidebarContext]=true
                         [cullId]="schedule?.timeCull?.id" [type]="'TimeCull'"
                         (submitSuccess)="filterSubmitSuccess($event)">
            </filter-edit>

            <sb-page-filter-list class="w-100 p-4" [isInIntegratedContext]="true"
                                 *ngIf="wizardState==='TimeCullSelect'" preselectType="TimeCull"
                                 (selectedFilter)="selectFilter($event)"></sb-page-filter-list>

            <filter-edit class="w-100 p-4" *ngIf="wizardState==='PlayerCullEdit'" [isInSidebarContext]=true
                         [cullId]="schedule?.playerCull?.id" [type]="'PlayerCull'"
                         (submitSuccess)="filterSubmitSuccess($event)"></filter-edit>

            <sb-page-filter-list class="w-100 p-4" [isInIntegratedContext]="true"
                                 *ngIf="wizardState==='PlayerCullSelect'" preselectType="PlayerCull"
                                 (selectedFilter)="selectFilter($event)"></sb-page-filter-list>

            <filter-edit class="w-100 p-4" *ngIf="wizardState==='GeoCullEdit'" [isInSidebarContext]=true
                         [cullId]="schedule?.geoCull?.id" [type]="'GeoCull'"
                         (submitSuccess)="filterSubmitSuccess($event)">
            </filter-edit>

            <sb-page-filter-list class="w-100 p-4" [isInIntegratedContext]="true"
                                 *ngIf="wizardState==='GeoCullSelect'" preselectType="GeoCull"
                                 (selectedFilter)="selectFilter($event)"></sb-page-filter-list>

            <div *ngIf="wizardState==='Map'">
              <sb-targeting-preview [isCollapsed]="true" [wizardPreviewState]="wizardPreviewState"
                                    (changeWizardState)="changeWizardPreviewState($event)"
                                    [campaignPreviewData]="previewSchedule">
              </sb-targeting-preview>
              <sb-cluster-map-legacy *ngIf="wizardPreviewState==='locationMap'" style="width: 100%;display: block;"
                                     [playerCull]="[schedule?.playerCull]" [scope]="ScreenScope.OWNED"></sb-cluster-map-legacy>
              <div *ngIf="wizardPreviewState==='locationList'" class="w-100 p-4" style="padding-top: 7rem!important;">
                <sb-page-inventory-wrapper [isInIntegratedContext]="true" [playerCull]="schedule?.playerCull"
                                           [geoCull]="schedule?.geoCull"></sb-page-inventory-wrapper>
              </div>
            </div>
          </div>
        </sb-wizard>
      </div>
    </sb-card>
  </div>
</div>
